import { Col, Row } from 'antd'
import './QuantityBreakdown.style.less'
import { quantity_breakdown_types_obj } from '@/screens/Order/constant/quanity_breakdown'
import GlassonBreakdown from './GlassonBreakdown'
import { size } from 'lodash'

interface Props {
  data: any
  dataSetting: any
  inspection?: any
}

function QuantityBreakdown(props: Props) {
  const found = props?.data?.all_sample_sizes.find((item) => item.color)
  const allSampleSizesNew = size(props?.data?.all_sample_sizes)
    ? props?.data?.all_sample_sizes[0].sub_items
    : []
  const allSampleSizes = found
    ? props?.data?.all_sample_sizes
    : allSampleSizesNew

  const sumTotal = (name) => {
    return allSampleSizes?.reduce((a, b) => {
      return (a = a + Number(b[name]))
    }, 0)
  }

  const isPartialInspection =
    props.inspection?.option?.partial_inspection?.status
  const spanItem = isPartialInspection ? 4 : 6
  const spanQty = isPartialInspection ? 5 : 6

  if (
    props.dataSetting[0]?.value?.report_setting?.new_qty_breakdown &&
    props.data?.quantity_breakdown ==
      quantity_breakdown_types_obj.BY_COLOR_AND_SIZE
  )
    return <GlassonBreakdown data={props.data} />
  return (
    <>
      {props.data?.quantity_breakdown !=
        quantity_breakdown_types_obj.BY_COLOR_AND_SIZE && (
        <Row className="color-size-containers">
          <Col span={12}>
            <Row>
              <p className="label-color-size">Sizes:</p>
              <p className="value-color-size">
                {props?.data?.sizes.map((item, index) => {
                  if (index == props?.data?.sizes?.length - 1) return item
                  return item + ', '
                })}
              </p>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <p className="label-color-size">Colors:</p>
              <p className="value-color-size">
                {props?.data?.colors.map((item, index) => {
                  if (index == props?.data?.colors?.length - 1) return item
                  return item + ', '
                })}
              </p>
            </Row>
          </Col>
        </Row>
      )}

      <div className="quantity-breakdown-container">
        <Row
          className="section-header-container report-page-break"
          justify={'space-between'}
        >
          <Col span={spanItem}>
            <p className="header" style={{ textAlign: 'left' }}>
              {props.data?.quantity_breakdown ==
              quantity_breakdown_types_obj.BY_DESTINATION
                ? 'Destination'
                : 'Item'}
            </p>
          </Col>
          <Col span={spanQty}>
            <p className="header" style={{ textAlign: 'center' }}>
              Order Quantity
            </p>
          </Col>
          {isPartialInspection && (
            <Col span={spanQty}>
              <p className="header" style={{ textAlign: 'center' }}>
                Inspection Qty
              </p>
            </Col>
          )}
          <Col span={spanQty}>
            <p className="header" style={{ textAlign: 'center' }}>
              Available Quantity
            </p>
          </Col>
          <Col span={spanQty}>
            <p className="header" style={{ textAlign: 'right' }}>
              Sample Size
            </p>
          </Col>
        </Row>
        {props?.data?.all_sample_sizes?.map((item, key) => {
          return (
            <Row
              key={key}
              className="section-value-container report-page-break"
              justify={'space-between'}
            >
              <Col span={spanItem}>
                <p className="value" style={{ textAlign: 'left' }}>
                  {props.data?.quantity_breakdown ==
                  quantity_breakdown_types_obj.TOTAL_QUANTITY_ONLY
                    ? item?.item
                    : props.data?.quantity_breakdown ==
                      quantity_breakdown_types_obj.BY_DESTINATION
                    ? item?.destination
                    : item?.color + '-' + item?.size}
                </p>
              </Col>
              <Col span={spanQty}>
                <p className="value" style={{ textAlign: 'center' }}>
                  {item.quantity ?? 0}
                </p>
              </Col>
              {isPartialInspection && (
                <Col span={spanQty}>
                  <p className="value" style={{ textAlign: 'center' }}>
                    {item?.inspectionQty ?? 0}
                  </p>
                </Col>
              )}
              <Col span={spanQty}>
                <p className="value" style={{ textAlign: 'center' }}>
                  {item?.actualQty ?? 0}
                </p>
              </Col>
              <Col span={spanQty}>
                <p
                  className="value"
                  style={{
                    textAlign: 'right',
                  }}
                >
                  {item.sampleSize}
                </p>
              </Col>
            </Row>
          )
        })}
        {props.data?.quantity_breakdown !==
          quantity_breakdown_types_obj.TOTAL_QUANTITY_ONLY && (
          <Row
            className="section-value-container bg-dark report-page-break"
            justify={'space-between'}
          >
            <Col span={spanItem}>
              <p className="value" style={{ textAlign: 'left' }}>
                Total
              </p>
            </Col>
            <Col span={spanQty}>
              <p className="value" style={{ textAlign: 'center' }}>
                {sumTotal('quantity')}
              </p>
            </Col>
            {isPartialInspection && (
              <Col span={spanQty}>
                <p className="value" style={{ textAlign: 'center' }}>
                  {sumTotal('inspectionQty')}
                </p>
              </Col>
            )}
            <Col span={spanQty}>
              <p className="value" style={{ textAlign: 'center' }}>
                {sumTotal('actualQty')}
              </p>
            </Col>
            <Col span={spanQty}>
              <p className="value" style={{ textAlign: 'right' }}>
                {sumTotal('sampleSize')}
              </p>
            </Col>
          </Row>
        )}
      </div>
    </>
  )
}

export default QuantityBreakdown
